import { type FC, useState } from "react";
import Modal from "@root/shared/components/Modal";
import { Button } from "@root/shared/components/Button";
import { TextButton } from "@root/shared/components/TextButton";
import { useCookies } from "react-cookie";
import * as styles from "./styles.css";

type Props = {
  impGaAction?: string;
  toPostPageGaAction?: string;
};

export const RequestGoogleReviewModal: FC<Props> = ({ impGaAction, toPostPageGaAction }) => {
  const [isModalOpen, setIsModalOpen] = useState(true);
  const [, , removeCookie] = useCookies(["show_google_review"]);

  const closeModal = () => {
    setIsModalOpen(false);
    // 一度閉じたら再表示しないようにする
    removeCookie("show_google_review", { path: "/" });
  };

  const handleGoogleReviewClick = () => {
    window.open("https://g.page/r/CdkpJNXPRMBSEAE/review", "_blank", "noopener,noreferrer");
    closeModal();
  };

  return (
    <Modal
      isShow={isModalOpen}
      onClose={closeModal}
      headerTitleStyle="none"
      pcWidthType="large"
      spAppearanceType="center"
    >
      <div data-ga-action={impGaAction} className={styles.container}>
        <img src="/images/shared/thank_you.png" alt="thank you" className={styles.thankYouImage} />
        <b className={styles.title}>Googleにも投稿しませんか？</b>
        <p className={styles.description}>
          よろしければご感想についてGoogle口コミにも投稿のご協力お願いします。
        </p>
        <div className={styles.buttonContainer}>
          <Button
            theme="primary"
            size="large"
            onClick={handleGoogleReviewClick}
            className={styles.primaryButton}
            data-ga-action={toPostPageGaAction}
          >
            Googleの口コミ投稿へ
          </Button>
          <TextButton size="large" onClick={closeModal} className={styles.textButton}>
            投稿しない
          </TextButton>
        </div>
      </div>
    </Modal>
  );
};
